import { Box, Container, Typography, Button, Paper, Divider, Stack } from '@mui/material';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import React, { Suspense, lazy } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const DefaultNavbar = lazy(() => import('components/DefaultNavbar'));

function Success() {
  const navigate = useNavigate();
  // const location = useLocation();
  // const payload = location.state?.calendlyPayload;

  const PreLoad = (
    <div className="h-screen w-100 flex items-center justify-center bg-black">
      {/* Loading placeholder */}
    </div>
  );

  return (
    <>
      <Suspense fallback={PreLoad}>
        <DefaultNavbar />
      </Suspense>
      <Box
        sx={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
          display: 'flex',
          flexDirection: 'column',
          pt: 12, // Ensure it's below the navbar
        }}
      >
        <Container maxWidth="sm" sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Paper
            elevation={12}
            sx={{
              p: { xs: 4, md: 6 },
              borderRadius: '24px',
              textAlign: 'center',
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
              animation: 'fadeInUp 0.6s ease-out',
              '@keyframes fadeInUp': {
                '0%': { opacity: 0, transform: 'translateY(20px)' },
                '100%': { opacity: 1, transform: 'translateY(0)' },
              },
            }}
          >
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: '50%',
                bgcolor: '#e6f4ea',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto',
                mb: 3,
                boxShadow: '0 0 0 10px rgba(76, 175, 80, 0.1)'
              }}
            >
              <EventAvailableIcon sx={{ fontSize: 40, color: '#4caf50' }} />
            </Box>

            <Typography
              variant="h4"
              sx={{
                mb: 2,
                fontWeight: 800,
                color: '#1a1a1a',
                fontFamily: 'Satoshi, sans-serif',
                letterSpacing: '-0.5px'
              }}
            >
              Meeting Confirmed!
            </Typography>

            <Typography
              variant="body2"
              sx={{
                mb: 4,
                color: '#555',
                lineHeight: 1.6,
              }}
            >
              Thank you for scheduling a meeting with us. We look forward to discussing your project requirements with you. A confirmation email has been sent to your inbox.
            </Typography>

            {/* {payload && payload.invitee && (
              <>
                <Divider sx={{ my: 3, opacity: 0.6 }} />
                <Box sx={{ mb: 4, p: 3, bgcolor: '#f8f9fa', borderRadius: '16px', border: '1px dashed #ccc' }}>
                  <Typography variant="subtitle2" sx={{ color: '#03a9f4', fontWeight: 700, mb: 1, textTransform: 'uppercase', letterSpacing: '1px' }}>
                    Registration Info Captured
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#444' }}>
                    <b>Event Reference:</b> {payload.event.uri.split('/').pop()}
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#444', mt: 1 }}>
                    <b>Invitee Reference:</b> {payload.invitee.uri.split('/').pop()}
                  </Typography>
                </Box>
              </>
            )} */}

            <Stack spacing={2} alignItems="center">
              <Button
                variant="contained"
                onClick={() => navigate('/')}
                endIcon={<ArrowForwardIcon />}
                sx={{
                  mt: 2,
                  backgroundColor: '#03a9f4',
                  color: 'white',
                  px: 5,
                  py: 1.5,
                  borderRadius: '30px',
                  fontSize: '1rem',
                  fontWeight: 600,
                  textTransform: 'none',
                  boxShadow: '0 8px 15px rgba(3, 169, 244, 0.3)',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    backgroundColor: '#0288d1',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 12px 20px rgba(3, 169, 244, 0.4)',
                  },
                }}
              >
                Return Home

              </Button>
              <Typography
                variant="caption"
                sx={{
                  mt: 2,
                  color: '#555',
                  lineHeight: 1.6,
                }}
              >
                Our team will contact you shortly.
              </Typography>
            </Stack>


          </Paper>

        </Container>
      </Box>
    </>
  );
}

export default Success;
